import { FullPageChat } from "flowise-embed-react";

const App = () => {
  const welcomeMessage =
    "안녕하세요. 이미지 분석을 시작하려면 범죄현장 이미지를 사건정보와 함께 업로드 해주세요. 준비가 완료되면 채팅을 시작해주세요.";

  return (
    <FullPageChat
      chatflowid="e7e2056f-60a2-488d-91b4-9cf7a183889f"
      // apiHost="http://192.168.1.21:4000"
      apiHost="https://chat.cnai.ai"
      theme={{
        chatWindow: {
          showTitle: true,
          showAgentMessages: false,
          title: "CNAI Chat Bot",
          titleAvatarSrc: "/logo_A_3.png",
          welcomeMessage: welcomeMessage,
          errorMessage: "에러가 발생했습니다. 잠시 후 다시 시도해주세요.",
          footer: {
            showFooter: false,
          },
        },
      }}
    />
  );
};

export default App;
